import styles from '../aside-styles.module.css';
import { Icon } from '../../../../components';
import { Icons } from '../../../../components/Icon/Icon';
import { ReactNode } from 'react';
import AsideMenuSub from './AsideMenuSub';

interface AsideMenuProps {
    id?: string;
    label?: string;
    icon?: Icons;
    collapsed?: boolean;
    disabled?: boolean;
    open?: boolean;
    onClick?: (id: string) => void;
    children?: ReactNode;
    isStandalone?: boolean;
}

const AsideMenu = ({ id, collapsed, disabled, open, onClick, label, children, icon, isStandalone }: AsideMenuProps) => {
    return (
        <div
            className={`${styles.menuItemsContainer} ${collapsed ? styles.collapsed : ''} ${isStandalone ? styles.standalone : ''}`}
        >
            <div className={`${styles.menuItem} ${disabled ? styles.disabled : ''}`}>
                {label && icon && (
                    <button className={styles.menuLabel} onClick={() => onClick?.(id!)}>
                        <Icon icon={icon} />
                        <span className={styles.menuText}>{label}</span>
                    </button>
                )}
                <AsideMenuSub open={open}>{children}</AsideMenuSub>
            </div>
        </div>
    );
};

export default AsideMenu;
